import styled, { css } from "styled-components";
import { divider, secondary } from "../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 1;
`;

export const Content = styled.div<{ type: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  font-size: 13px;
  z-index: 10;
  ${props => props.type === 1 && css`
    background-color: #221e1e;
    color: #FFF;
  `}
  ${props => props.type === 2 && css`
    background-color: #FFF;
  `}
`;

export const ContainerTop = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 30px 30px 30px;
  border-bottom: 1px solid ${divider.light};
`;

export const ContainerBottomButtons = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  border-top: 1px solid ${divider.light};
`;

export const Form = styled.form`
  flex: 1;
  padding: 15px 30px 30px 30px;
  overflow: auto;

  @media (max-width: 359px) {
    max-height: calc(calc(100 * var(--vh)) - 419px);
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
`;

export const Description = styled.div`
  font-size: 13px;
`;

export const LogoImg = styled.img`
  object-fit: contain;
`;

export const ContainerTerms = styled.div`
  margin-top: 10px;
  text-align: center;
`;

export const AnchorTerms = styled.a`
  text-decoration: none;
  color: #212529;
`;

export const Span = styled.span`
  color: ${secondary.light};
`;
